import { render, staticRenderFns } from "./KjpTiles.vue?vue&type=template&id=e2a5e1da&scoped=true&"
import script from "./KjpTiles.vue?vue&type=script&lang=js&"
export * from "./KjpTiles.vue?vue&type=script&lang=js&"
import style0 from "./KjpTiles.vue?vue&type=style&index=0&id=e2a5e1da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a5e1da",
  null
  
)

export default component.exports